<!--
  @ModuleTabs  Underline tabs to the pages of a module (below the navigation bar, grid area 'head').
-->

<script>
		/** tabs: [{id, label, icon, info?: tooltip, count?: number shown as badge}] **/
		let {tabs = [], selected = null, onselect} = $props()
</script>


<div class="tabs" role="tablist">
	{#each tabs as tab (tab.id)}
		<button role="tab" class="tab" class:selected={selected === tab.id} aria-selected={selected === tab.id}
		        title={tab.info} onclick={() => onselect?.(tab.id)}>
			<i class="fa icon-{tab.icon}"></i>{tab.label}
			{#if tab.count !== undefined}<span class="count">{tab.count}</span>{/if}
		</button>
	{/each}
</div>


<style lang="sass">
	@use "../colors" as colors

	.tabs
		grid-area: head
		height: 51px
		display: flex
		align-items: stretch
		gap: 4px
		padding: 0 16px
		overflow-x: auto
		scrollbar-width: none
		background: linear-gradient(to right, transparent, colors.$grey-30 48px, colors.$grey-30 calc(100% - 48px), transparent) no-repeat bottom / 100% 1px

	.tab
		display: flex
		align-items: center
		gap: 8px
		margin: 0
		padding: 0 14px
		border: 0
		border-radius: 0
		background: transparent
		color: colors.$grey-60
		font-size: 14px
		white-space: nowrap
		cursor: pointer

		.fa
			font-size: 14px

		&:hover
			color: colors.$white

		&.selected
			color: colors.$white
			box-shadow: inset 0 -2px 0 colors.$primary-100

			.fa
				color: colors.$primary-100

		&:focus-visible
			outline: 2px solid colors.$primary-100
			outline-offset: -2px

	.count
		padding: 0 7px
		border-radius: 9px
		background: colors.$grey-20
		color: colors.$grey-85
		font-size: 11px
</style>
